import { SoftwareInventoryService } from 'src/app/service/software-inventory.service';
import { ProductDownloadInfo } from './../../model/DownloadStatus';
import { ExtVendorFile } from './../../model/ExtVendorFile';
import { ColumnSort, ColumnType, DataTableColumn, DataTableColumnFilter, DataTableDropDownData, DataTableDropDownOption, DataTableRow, DataTableRowDensity, FilterType } from './../controls/datatable/datatable.component';
import { EventService } from './../../service/event.service';
import { Plan, Step, Parameter, Variable, SystemVariable, STEP_VALIDATION_TYPE, StepValidation, StepUI } from './../../model/Plan';
import { PlanService } from './../../service/plan.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { tap, finalize, catchError } from 'rxjs/operators';
import { of, Subscription } from 'rxjs';
import { Environment, SolutionInfo } from '../../model/SolutionInfo';
import { Utils } from 'src/app/utils';
import { ActionMenuEvent, ActionMenuIcon, ActionMenuItem } from '../controls/actionmenu/action-menu.component';
import { PlanCallbackService } from 'src/app/service/plan-callback.service';
import { Agent, AgentStatus, AgentStatusValue } from 'src/app/model/Agent';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ModalControl, ModalControlType, ModalMessageComponent, ModalMessageType, ModalResult } from '../controls/modal-message/modal-message.component';
import { Modal } from '../controls/modal/modal.service';
import { Events } from 'src/app/service/websocket.service';
import { PlansFormMode } from '../plans-form/plans-form.component';
import { FormGroup } from '@angular/forms';
import { ExtVendorFileService } from 'src/app/service/ext-vendor-file.service';
import { ModalConfig } from '../controls/modal/modal-config';
import { Tab, TabColor } from '../controls/tabs/tabs.component';
import { AgentService } from 'src/app/service/agent.service';
import { CookieService } from 'ngx-cookie-service';

enum PlansDetailsState {INIT, VIEW_DETAILS, SELECT_STEP}
enum PlanSaveState {SAVE_DETAILS, SAVE_PLAN, SAVE_AND_EXECUTE}
enum PlanDetailsTab {STEPS, VARIABLES, SYSTEM_VARIABLES}
@Component({
    selector: 'app-plans-details',
    templateUrl: './plans-details.component.html',
    styleUrls: ['./plans-details.component.css', '../plans/plans.component.css'],
    standalone: false
})
export class PlansDetailsComponent implements OnInit {
  planId: number;
  plan: Plan;
  planCopy: Plan;
  deploymentSteps: Step[] = []; //available steps
  TabColor = TabColor;
  PlanDetailsTab = PlanDetailsTab;
  activeTab: PlanDetailsTab = PlanDetailsTab.STEPS;
  stepsTab = new Tab('plan-details-step-tab', $localize`Steps`, 0, false);
  variablesTab = new Tab('plan-details-variables-tab', $localize`Variables`, 0, false);
  sysVariablesTab = new Tab('plan-details-system-variables-tab', $localize`System Variables`, 0, false);
  tabs: Tab[] = [this.stepsTab, this.variablesTab, this.sysVariablesTab];
  solutionInfo : SolutionInfo;
  detailState:PlansDetailsState = PlansDetailsState.INIT;
  PlansDetailsState = PlansDetailsState;
  PlanSaveState = PlanSaveState;
  recountSelectedRow:boolean = false;
  recountSelectedRowStepsTable:boolean = false;
  recountSelectedSystemVarTable:boolean = false;
  mode:PlansFormMode = PlansFormMode.EDIT;
  PlansFormMode = PlansFormMode;
  formGroup: FormGroup;
  isOkToDeactivate:boolean = false;
  forceRefreshComp:boolean = false;
  
  //current step details
  currentStep:Step;
  currentStepCopy:Step;
  planVariablesCopy:Variable[];
  activeDetailsTab: number = 0;
  currentStepTab:string = '';
  currentStepTabs:Tab[] = [];
  isCurrentStepLoading:boolean = false;

  //steps table
  isStepTableLoading:boolean = false;
  stepCols:DataTableColumn[] = [];
  stepRows:DataTableRow[] = [];
  stepRowDensity:DataTableRowDensity = DataTableRowDensity.MEDIUM;

  //system variables table
  systemVarCols:DataTableColumn[] = [];
  systemVarRows:DataTableRow[] = [];

  //deployment steps table
  deploymentStepCols:DataTableColumn[] = [];
  deploymentStepRows:DataTableRow[] = [];
  stepListTableTitle:string = $localize`Available steps`;

  systemVariableOptions:DataTableDropDownOption[] = [];
  stepSystemVariableOptions:DataTableDropDownOption[] = [];

  //subscription
  solutionInfoSubscription: Subscription;
  eventMessageSubscription: Subscription;

  buttonPending: boolean = false;

  multiStepType: string = "MULTI_SYSTEM_CONFIGURATION";

  constructor(private route: ActivatedRoute, private planSrv: PlanService, private eventService: EventService, private modal: Modal,
              private router: Router, private extVenFileSrv: ExtVendorFileService, private softInvSrv:SoftwareInventoryService,
              private agentSrv: AgentService, private cookieSrv: CookieService) {
    if(route.snapshot.data['breadcrumb'] == 'New'){
       this.mode = PlansFormMode.ADD;
    }else if(route.snapshot.data['breadcrumb'] == 'Details'){
      this.mode = PlansFormMode.EDIT;
    }
  }

  ngOnInit(): void {
    this.solutionInfoSubscription = this.eventService.currentSolutionInfo$.subscribe(newSolutionInfo => {
      // update existing
      if(this.solutionInfo){
        this.solutionInfo = newSolutionInfo;
        this.systemVariableOptions = [new DataTableDropDownOption($localize`Select a system`, '')];
        
        let env:Environment = this.getEnv(this.plan.selectedEnvironmentId);
        if(env && env.agents){
          env.agents.forEach((agent) => {
            this.systemVariableOptions.push(new DataTableDropDownOption(agent.systemName, agent.macAddress));
          });
        }
        
        //update existing system variable table
        this.systemVarRows.forEach( row => {
          //update options
          row.data.systemList.options = this.systemVariableOptions;
          //reset value if system longer exists
          let index:number = this.systemVariableOptions.findIndex( option => {
            return option.name == row.data.systemList.value;
          });

          if(index < 0){
            row.data.systemList.value = '';
            row.data.macAddress = '';
            row.data.systemStatus = new AgentStatus(AgentStatusValue.OFFLINE, 'otsc-icon-status-outdated', $localize`Agent status is unknown`);
          }else{
            let agent:Agent = this.solutionInfo.currentEnvironment.agents.find(agent => agent.systemName == row.data.systemList.value );
            if(agent){
              row.data.systemStatus = Utils.getAgentStatus(agent);
            }
          }
        });
      // first time
      }else{
        this.solutionInfo = newSolutionInfo;
        
        if(this.mode == PlansFormMode.ADD){
          this.planSrv.getDeploymentSteps().pipe(
            tap(resp => {
              this.deploymentSteps = resp.body;
              this.deploymentSteps.sort((a, b) => (a.product.localeCompare(b.product) || a.nickname.localeCompare(b.nickname)));
              this.plan = new Plan();
              this.plan.selectedEnvironmentName = this.solutionInfo.currentEnvironment.name;
              this.plan.selectedEnvironmentId = this.solutionInfo.currentEnvironment.id;
              this.systemVariableOptions = [new DataTableDropDownOption($localize`Select a system`, '')];
              this.stepSystemVariableOptions = [];

              //fill in default system variable options from current environment agents
              let env:Environment = this.getEnv(this.plan.selectedEnvironmentId);
              if(env && env.agents){
                env.agents.forEach((agent) => {
                  this.systemVariableOptions.push(new DataTableDropDownOption(agent.systemName, agent.macAddress));
                  this.stepSystemVariableOptions.push(new DataTableDropDownOption(agent.nickName, agent.systemName));
                });
              }

              this.stepSystemVariableOptions = this.stepSystemVariableOptions.sort((a, b) => ((a.name < b.name) ? -1: 1));
              this.stepSystemVariableOptions.unshift(new DataTableDropDownOption($localize`Select a system variable`, ''));

              //set default System variables
              this.solutionInfo.currentEnvironment.agents.forEach((agent) => {
                let sysVar = {systemVarName: agent.nickName,
                              prevSystemVarName: agent.nickName,
                              systemList: new DataTableDropDownData(agent.systemName, this.systemVariableOptions),
                              systemStatus: agent ? Utils.getAgentStatus(agent) : new AgentStatus(AgentStatusValue.OFFLINE, 'otsc-icon-status-outdated', $localize`Agent status is unknown`),
                              macAddress: agent.macAddress,
                            };
                let newSysVarRow:DataTableRow = new DataTableRow(sysVar, [new ActionMenuItem("Delete", $localize`Remove`, ActionMenuIcon.DELETE, sysVar, true)]);
                this.systemVarRows.push(newSysVarRow);
              });
             this.setCounts();
            }),
            finalize(() => {
              setTimeout(()=> this.isStepTableLoading = false, 500);
            })
          ).subscribe();
        }else if(this.mode == PlansFormMode.EDIT){
          this.planSrv.getDeploymentSteps().pipe(
            tap(resp => {
              this.deploymentSteps = resp.body;
              this.deploymentSteps.sort((a, b) => (a.product.localeCompare(b.product) || a.nickname.localeCompare(b.nickname)));
              this.planSrv.getPlan(this.planId).pipe(
                tap(resp => {
                  this.plan = resp.body;
                  this.stepSystemVariableOptions = [];
                  this.systemVariableOptions = [new DataTableDropDownOption($localize`Select a system`, '')];
    
                  //fill in default system variable options from current environment agents
                  let env:Environment = this.getEnv(this.plan.selectedEnvironmentId);
                  if(env && env.agents){
                    env.agents.forEach((agent) => {
                      this.systemVariableOptions.push(new DataTableDropDownOption(agent.systemName, agent.macAddress));
                    });
                  }
    
                  //set system variable
                  this.plan.systemVariables.forEach(sysVar => {
                    let agent:Agent = this.getAgentByMacaddress(this.plan.selectedEnvironmentId, sysVar.value);
    
                    let sysVarData = {systemVarName: sysVar.name ,
                                      prevSystemVarName: sysVar.name ,
                                      systemList: agent ? new DataTableDropDownData(agent.systemName, this.systemVariableOptions) : new DataTableDropDownData('', this.systemVariableOptions),
                                      systemStatus: agent ? Utils.getAgentStatus(agent) : new AgentStatus(AgentStatusValue.OFFLINE, 'otsc-icon-status-outdated', $localize`Agent status is unknown`),
                                      macAddress: agent ? agent.macAddress : '',
                                     };
                    let newSysVarRow:DataTableRow = new DataTableRow(sysVarData, [new ActionMenuItem("Delete", $localize`Remove`, ActionMenuIcon.DELETE, sysVar, true)]);
                    if(newSysVarRow.data.systemVarName == ''){
                      newSysVarRow.error = true;
                      newSysVarRow.errorText = $localize`Please enter system variable name` ;
                    }else if (newSysVarRow.data.systemList.value == ''){
                      newSysVarRow.error = true;
                      newSysVarRow.errorText = $localize`Please select a system` ;
                    }
                    
                    this.systemVarRows.push(newSysVarRow);
                    //set step system variable.
                    this.stepSystemVariableOptions.push(new DataTableDropDownOption(sysVarData.systemVarName, sysVarData.systemVarName));
                  });
    
                  //order system variable
                  this.stepSystemVariableOptions = this.stepSystemVariableOptions.sort((a, b) => ((a.name < b.name) ? -1: 1));
                  this.stepSystemVariableOptions.unshift(new DataTableDropDownOption($localize`Select a system variable`, ''));
    
                  //steps table
                  this.plan.steps.forEach(((step, index) => {
                    this.setInitialData(step);
                    //variables
                    Object.values(step.parameters).forEach((param) => {
                      if(param.variableName){
                        let existingVar:Variable = this.plan.variables.find((v) => {return v.name == param.variableName && v.type == param.type;});
    
                        if(existingVar){
                          param.value = existingVar.value;
                          existingVar.parameter = JSON.parse(JSON.stringify(param));
                        }
                      }
                    });
    
                    let foundDStep = this.deploymentSteps.find(dStep => dStep.nickname == step.nickname);
                    if(foundDStep){
                      let row:DataTableRow = new DataTableRow(this.updateStep(step, JSON.parse(JSON.stringify(foundDStep))), this.getStepMenu(index, step));
                      row.canDrag = true;
                      row.disableDropdown = (step.type == this.multiStepType);
                      this.stepRows.push(row);
                    }
                  }));
                  this.planCopy = JSON.parse(JSON.stringify(this.plan)); //make a copy of the original plan
                  this.setCounts();
                }),
                catchError(resp => {
                  Utils.addHeaderMessageEventBanner(this.eventService, Events.WarningMsg, $localize`The selected plan was not found. Click the filter icon to find a plan by name.`);
                  this.isOkToDeactivate = true;
                  this.router.navigate(['/plans/overview']);
                  return of(resp);
                })
              ).subscribe();
            }),
            finalize(() => {
              setTimeout(()=> this.isStepTableLoading = false, 500);
            })
          ).subscribe();
        }
      }
    });

    this.eventMessageSubscription = this.eventService.eventMessage$.subscribe(msg => {
      switch(msg.eventType){
        case Events.AgentManifestStart:
        case Events.AgentManifestComplete:
          this.agentSrv.listAll(this.solutionInfo.currentEnvironment.id).pipe(
            tap(resp => {
              this.solutionInfo.currentEnvironment.agents = resp.body;
              this.systemVarRows.forEach( row => {
                //update options
                row.data.systemList.options = this.systemVariableOptions;
                //reset value if system longer exists
                let index:number = this.systemVariableOptions.findIndex( option => {
                  return option.name == row.data.systemList.value;
                });
      
                if(index < 0){
                  row.data.systemList.value = '';
                  row.data.macAddress = '';
                  row.data.systemStatus = new AgentStatus(AgentStatusValue.OFFLINE, 'otsc-icon-status-outdated', $localize`Agent status is unknown`);
                }else{
                  let agent:Agent = this.solutionInfo.currentEnvironment.agents.find(agent => agent.systemName == row.data.systemList.value );
                  if(agent){
                    row.data.systemStatus = Utils.getAgentStatus(agent);
                  }
                }
              });
            }),
            finalize(() => {
              setTimeout(()=> this.isStepTableLoading = false, 500);
            })
          ).subscribe();
          break;
      }
    });

    //set columns
    this.stepCols = Array<DataTableColumn>(new DataTableColumn("dragHandle", ' ', ColumnType.DRAGHANDLE, false, "0"),
                                           new DataTableColumn("uiDisplayName", $localize`Name`, ColumnType.HTML, false, "65"),
                                           new DataTableColumn("uiStatus", $localize`Status`, ColumnType.STATUSEXT, false, "10"),
                                           new DataTableColumn("uiSystemVariables", $localize`System Variable`, ColumnType.DROPDOWN, false, "25"),
                                          );
    this.systemVarCols = Array<DataTableColumn>(new DataTableColumn("systemVarName", $localize`Name`, ColumnType.TEXTBOX, false, "42"),
                                                new DataTableColumn("systemList", $localize`System`, ColumnType.DROPDOWN, false, "48"),
                                                new DataTableColumn("systemStatus", $localize`Status`, ColumnType.STATUSEXT, false, "10"),
                                               );
    this.deploymentStepCols = Array<DataTableColumn>(new DataTableColumn("product", $localize`Product`, ColumnType.STRING, true, "16", ColumnSort.ASC, undefined, new DataTableColumnFilter(FilterType.STRING)),
                                                     new DataTableColumn("nickname", $localize`Name`, ColumnType.STRING, true, "22", undefined, undefined, new DataTableColumnFilter(FilterType.STRING)),
                                                     new DataTableColumn("summary", $localize`Description`, ColumnType.STRING, false, "50"),
                                                     new DataTableColumn("platform", $localize`Platform`, ColumnType.STRING, true, "12", undefined, undefined, new DataTableColumnFilter(FilterType.STRING)),
                                                    );
    this.init();
  }

  ngOnDestroy() {
    this.solutionInfoSubscription.unsubscribe();
    this.eventMessageSubscription.unsubscribe();
  }

  canDeactivate() : boolean{
    let canDeactivate:boolean = true;

    if(!this.isOkToDeactivate){
      if(this.mode == PlansFormMode.ADD){
        if(this.formGroup.dirty || this.stepRows.length > 0){
          canDeactivate = false; //plan is not saved
        }
      }else if(this.mode == PlansFormMode.EDIT){
        if(JSON.stringify(this.plan) != JSON.stringify(this.planCopy)){
          canDeactivate = false;
        }
      }
    }

    return canDeactivate;
  }

  getDeactivateModalMessageConfig(): ModalConfig {
    return Utils.getDefaultDeactivateModalMessageConfig(this.mode == PlansFormMode.ADD ? 'otsc-plans-add-unsaved-changes' : 'otsc-plans-edit-unsaved-changes');
  }

  // 
  // Plan
  //

  //find agent by environment id
  getEnv(envId:number): Environment {
    let env:Environment[] = this.solutionInfo.environments.filter(env => {
      return env.id == envId;
    });

    return env.length > 0 ? env[0] : undefined;
  }

  //find agent by environment id and agent system name
  getAgentBySysName(envId:number, systemName: string): Agent {
    let agent:Agent;
    let env:Environment = this.getEnv(envId);
    
    if(env && env.agents){
      let agents:Agent[] = env.agents.filter( agent => {
        return agent.systemName == systemName;
      });

      if(agents.length > 0){
        agent = agents[0];
      }
    }

    return agent;
  }

  //find agent by environment id and agent system name
  getAgentByMacaddress(envId:number, macAddress: string): Agent {
    let agent:Agent;
    let env:Environment = this.getEnv(envId);
    
    if(env && env.agents){
      let agents:Agent[] = env.agents.filter( agent => {
        return agent.macAddress == macAddress;
      });

      if(agents.length > 0){
        agent = agents[0];
      }
    }

    return agent;
  }

  // when save button is clicked
  save(state: PlanSaveState): void {
    this.plan.steps = [];
    this.buttonPending = true;
    //fill in steps
    this.stepRows.forEach(((row, index) => {
      let step:Step = row.data.step;
      step.stepNo = index;
      step.selectedSystemVar = {name: row.data.uiSystemVariables.value, value: undefined, count: 0};
      this.plan.steps.push(step);
    }));

    //fill in system variables
    this.systemVarRows.forEach( row => {
      if(row.data.systemVarName != ''){
        let agent:Agent = this.getAgentBySysName(this.plan.selectedEnvironmentId, row.data.systemList.value);

        if(agent){
          let index:number = this.plan.systemVariables.findIndex( v => {
            return v.name == row.data.systemVarName;
          });

          if(index > -1){
            this.plan.systemVariables[index].value = agent.macAddress;
          }else{
            this.plan.systemVariables.push({name: row.data.systemVarName, value: agent.macAddress, count: 0});
          }
        }
      }
    });

    //fill in variables
    this.plan.steps.forEach( step => {
      Object.values(step.parameters).forEach(param => {
        if(param.variableName && param.variableName != ''){
          let existingVar:Variable = this.plan.variables.find((v) => {return v.name == param.variableName && v.type == param.type;});
  
          if(existingVar){
            if(existingVar.type ==='PRODUCT_FILE'){
              param.value = existingVar.value?.name;
            }else if(existingVar.type === 'EXT_FILE'){
              param.value = existingVar.value?.localFilename ? existingVar.value.localFilename : existingVar.value?.name;
            }else if(existingVar.type === 'INT'){
              param.value = existingVar.value?.toString();
            } else if (existingVar.type == 'BOOLEAN') {
              param.value == existingVar.value ? 'true' : 'false';
            }else{
              param.value = existingVar.value;
            }
            step.variableMap = {};
            step.variableMap[existingVar.name] = param.value;
          }
        }else{
          if(param.type ==='PRODUCT_FILE' && param.value){
            param.value = param.value.name ? param.value.name : param.value;
          }else if(param.type === 'EXT_FILE' && param.value){
            param.value = param.value.localFilename ? param.value.localFilename : param.value;
          }else if(param.type === 'INT' && param.value){
            param.value = param.value.toString();
          }else if(param.type == 'BOOLEAN'){
            param.value == param.value ? 'true' : 'false';
          }
        }
      });
    });

    this.plan.variables.forEach( variable => {
      if (variable.type == 'BOOLEAN' ){
        variable.value = variable.value ? 'true' : 'false';
      }
    });

    //set save type
    this.plan.saveType = this.mode === PlansFormMode.ADD ? 'new' : 'edit';

    if(state == PlanSaveState.SAVE_AND_EXECUTE){
      if(Utils.isSystemUpdateForced(this.solutionInfo)){
        Utils.openUpdateRequiredDialog(this.modal);
        this.buttonPending = false;
      }else{
        //confirm saving the plan before executing
        const sub: Subscription =
          this.modal.open(ModalMessageComponent, {
            data: {
              title: $localize`Execute`,
              message: $localize`The selected plan will be saved and validated. Would you like to continue?`,
              primaryBtn: $localize`Continue`,
              secondaryBtn: $localize`Cancel`,
              type: ModalMessageType.Question,
              width: '450px'
            },
            id: 'otsc-plans-save-and-exec-msg'
          }
          ).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
            if (isPrimaryBtnClicked) {
              this.planSrv.savePlan(this.plan).pipe(
                tap(resp => {
                  if(resp.body.id > 0){
                    this.isOkToDeactivate = true;
                    this.router.navigate(['/plans/execute/' + resp.body.id]);
                  }else{
                    Utils.addHeaderMessageEventBanner(this.eventService, Events.ErrorMsg, $localize`${this.plan.name} could not be saved. Please try again later.`);
                  }
                }),
                finalize(() => {})
              ).subscribe();
            }else{
              //user decided not to save and execute
              this.plan = this.planCopy;
            }
            this.buttonPending = false;
            sub.unsubscribe();
          });
      }
    }else{
      this.planSrv.savePlan(this.plan).pipe(
        tap(resp => {
          if(resp.body.id > 0){
            if(state == PlanSaveState.SAVE_PLAN){
              this.planCopy = JSON.parse(JSON.stringify(this.plan)); //update the copy
              Utils.addHeaderMessageEventBanner(this.eventService, Events.SuccessMsg, $localize`${this.plan.name} was saved successfully.`);
              this.buttonPending = false;
            }else if(state == PlanSaveState.SAVE_DETAILS){
              if(this.mode === PlansFormMode.ADD){
                this.mode = PlansFormMode.EDIT; //now the plan is in edit mode
                this.plan.id = resp.body.id;
              }
              this.stepRows[this.currentStep.stepNo].data = this.updateStep(this.currentStep, undefined, this.stepRows[this.currentStep.stepNo].data.uiSystemVariables);
              this.planCopy = JSON.parse(JSON.stringify(this.plan)); //update the copy
              Utils.addHeaderMessageEventBanner(this.eventService, Events.SuccessMsg, $localize`${this.plan.name} was saved successfully.`);
              this.buttonPending = false;
            }
  
          }else{
            Utils.addHeaderMessageEventBanner(this.eventService, Events.ErrorMsg, $localize`${this.plan.name} could not be saved. Please try again later.`);
          }
        }),
        finalize(() => {
         
        })
      ).subscribe();
    }
  }

  //got plans overview page when the close button is clicked
  close(): void {
    this.router.navigate(['/plans/overview']);
  }

  //revert step details change
  revertStepDetails(): void {
    const sub: Subscription =
      this.modal.open(ModalMessageComponent, {
        data: {
          title: $localize`Revert`,
          message: $localize`Any changes made in this step will be reverted. Revert the changes?`,
          primaryBtn: $localize`Revert`,
          secondaryBtn: $localize`Cancel`,
          width: '350px',
        },
        id: 'otsc-plans-step-revert'
      }
      ).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
        if (isPrimaryBtnClicked) {
          this.currentStep = this.currentStepCopy;
          this.plan.variables = this.planVariablesCopy;
          if(this.currentStep && this.currentStep.stepNo !== undefined){
            this.plan.steps[this.currentStep.stepNo] = this.currentStep;
            this.stepRows[this.currentStep.stepNo].data = this.updateStep(this.currentStep, undefined, this.stepRows[this.currentStep.stepNo].data.uiSystemVariables);
            this.setCurrentStep(this.currentStep.stepNo);
            this.setCounts();
          }
        }
        sub.unsubscribe();
      });
  }
  
  //go back to plan details
  goBackToPlanDetails():void {
    //warn users if the changes are not saved
    if(!this.canDeactivate()){
      const sub: Subscription =
                this.modal.open(ModalMessageComponent, this.getDeactivateModalMessageConfig()
                ).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
                  if(!isPrimaryBtnClicked){
                    //revert changes
                    this.currentStep = this.currentStepCopy;
                    this.plan.variables = this.planVariablesCopy;
                    if(this.currentStep && this.currentStep.stepNo != undefined){
                      this.plan.steps[this.currentStep.stepNo] = this.currentStep;
                      this.stepRows[this.currentStep.stepNo].data = this.updateStep(this.currentStep, undefined, this.stepRows[this.currentStep.stepNo].data.uiSystemVariables);
                      this.setCounts();
                    }
                    this.detailState = PlansDetailsState.INIT;
                  }
                  sub.unsubscribe();
                });
    }else{
      if(this.currentStep){
        this.stepRows[this.currentStep.stepNo].data = this.updateStep(this.currentStep, undefined, this.stepRows[this.currentStep.stepNo].data.uiSystemVariables);
        this.currentStep = undefined;
        this.currentStepCopy = undefined;
      }
      
      this.detailState = PlansDetailsState.INIT;
    }
  }
  
  //update plan form
  updateForm(formGroup:FormGroup): void {
    setTimeout(() => {
      this.formGroup = formGroup;
      this.plan.name = this.formGroup.get('nameCtrl').value;
      this.plan.description = this.formGroup.get('descriptionCtrl').value;
    });
  }

  //handle when add item button clicked
  onAddItemClick(): void {
    //check if the plan can be saved
    if(this.formGroup.invalid){
      const sub: Subscription =
          this.modal.open(ModalMessageComponent, {
            data: {
              title: $localize`Warning`,
              message: $localize`Please enter a plan name before adding steps.`,
              primaryBtn: $localize`OK`,
              type: ModalMessageType.Warning,
              width: '450px'
            },
            id: 'otsc-plans-enter-plan-name-msg'
          }
          ).afterClosed.subscribe(() => {
            sub.unsubscribe();
          });
    }else{
      this.showDeploymentSteps();
    }
  }

  //check if there's any errors
  hasStepsWithError(): boolean {
    let numStepChecked:number = 0;

    let index:number = this.stepRows.findIndex( row => {
      if(!row.data.step.disabled){
        numStepChecked++;
        return row.data.uiStepValidation.type != STEP_VALIDATION_TYPE.VALID;
      }else{
        return false;
      }
    });

    return numStepChecked == 0 || index > -1;
  }

  //set current tab
  onSelectedTabChange(selectedIndex: number) {
    var tab = this.tabs[selectedIndex];
    this.activeTab = selectedIndex;
    if (tab.text == 'Steps') {
      this.stepRows.forEach(row => {
        row.data.uiStepValidation = this.validateStep(row.data, this.plan.variables);
        row.data.uiStatus = this.getStepStatus(row.data);
      });
    }
  }

  //
  // Steps
  //

  //handle when steps are dragged and droppped
  drop(event: CdkDragDrop<DataTableRow[]>) {
   moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    
    //update step inline menus and step no. index
    event.container.data.forEach((row, index) =>{
      row.actions = this.getStepMenu(index, row.data.step);
      row.data.step.stepNo = index;
    });
  }

  //validate parameter dependencies
  validateDependency(step:Step): void {
    let parameters:Parameter[] = Object.values(step.parameters);

    parameters.forEach((param) => {
      if(param.dependencies){
        let isDependencyValidated:boolean = true;

        for(let dep of param.dependencies){
          let p = step.parameters[dep.name];

          //check for callback
          if(dep.callback && typeof PlanCallbackService[dep.callback] === "function"){
            isDependencyValidated = PlanCallbackService[dep.callback](step.parameters, dep, dep.callbackValue);
            if(!isDependencyValidated){
              break;
            }
          }else{
            if(p.type == 'BOOLEAN') {
              let depValue = (typeof dep.value == "boolean") ? dep.value : (dep.value == 'true');
              let paramDepValue = (typeof p.value == "boolean") ? p.value : (p.value == 'true');
              if(dep.name === p.name && paramDepValue !== depValue){
                isDependencyValidated = false;
                break;
              }
            } else {
              if(dep.name === p.name && (p.value == '' || p.value !== dep.value)){
                isDependencyValidated = false;
                break;
              }
            }
          }
        }

        param.visible = isDependencyValidated; //only visible if dependency is validated
      }

      if(param.valueList && param.valueList.length > 0){
        param.valueList.forEach(listValue => {
          if(listValue.dependencies && listValue.dependencies.length > 0){
            let isDependencyValidated:boolean = true;

            for(let dep of listValue.dependencies){    
              //check for callback
              if(dep.callback && typeof PlanCallbackService[dep.callback] === "function"){
                isDependencyValidated = PlanCallbackService[dep.callback](step.parameters, dep, dep.callbackValue);
                if(!isDependencyValidated){
                  break;
                }
              }
            }
    
            listValue.visible = isDependencyValidated; //only visible if dependency is validated
          } else if(param.changeEvent && typeof PlanCallbackService[param.changeEvent] === "function") {
            PlanCallbackService[param.changeEvent](step, param);
          }
        });
      }

      if(param.type == "LIST" && param.defaultListValue && param.defaultListValue.length > 0){
        param.defaultListValue.forEach(listValue => {
          if(listValue.dependencies && listValue.dependencies.length > 0){
            let isDependencyValidated:boolean = true;

            for(let dep of listValue.dependencies){    
              //check for callback
              if(dep.callback && typeof PlanCallbackService[dep.callback] === "function"){
                isDependencyValidated = PlanCallbackService[dep.callback](step.parameters, dep, dep.callbackValue);
                if(!isDependencyValidated){
                  break;
                }
              }
            }
    
            listValue.visible = isDependencyValidated; //only visible if dependency is validated
          } else if(param.changeEvent && typeof PlanCallbackService[param.changeEvent] === "function") {
            PlanCallbackService[param.changeEvent](step, param);
          }
        });
      }
    });

    step.parameterGroups = [$localize`Default`]; //default group name
    Object.values(step.parameters).sort((a, b) => ((a.group <= b.group) ? -1: 1)).forEach((param, i) => {
      if(param.group !== '' && param.visible && step.parameterGroups.indexOf(param.group) < 0){
        step.parameterGroups.push(param.group);
      }
    });

    //sort by tab order
    if(step.tabOrder && step.tabOrder.length > 0){
      let orderedTab:string[] = [];

      step.tabOrder.forEach( tab => {
        let isFound:boolean = false;

        step.parameterGroups.filter( g => {
          if(!isFound && g == tab) {
            orderedTab.push(tab);
            isFound = true;
            return false;
          } else {
            return true;
          }
        });
      });
      step.parameterGroups = orderedTab;
    }

    //set tabs
    this.currentStepTabs = [];
    step.parameterGroups.forEach((tab) => {
      this.currentStepTabs.push(new Tab(tab, tab, undefined, this.currentStepTab == tab));
    });
  }

  //set active tab
  onSelectedDetailsTabChange(selectedIndex: number) {
    var tab = this.currentStepTabs[selectedIndex];
    this.currentStepTab = tab.id;
    this.activeDetailsTab = selectedIndex;
  }

  //update step with the latest changes
  updateStep(step:Step, foundDStep:Step, sysVar:DataTableDropDownData = undefined): StepUI {
    let newStepUI:StepUI = new StepUI();
    newStepUI.step = step;

    if(foundDStep){
      newStepUI.step.summary = foundDStep.summary;

      //update parameters
      Object.values(foundDStep.parameters).forEach((param) => {
        if(newStepUI.step.parameters[param.name]){
          param.value = step.parameters[param.name].value;
          param.data = step.parameters[param.name].data;
          param.variableName = step.parameters[param.name].variableName;
          param.valueList = step.parameters[param.name].valueList;
          param.objectList = step.parameters[param.name].objectList;
        }
        
      });
      if(step.type == this.multiStepType) {
        Object.keys(step.parameters).forEach(key =>{
          if(step.parameters[key].isClusterValue){
            foundDStep.parameters[key] = step.parameters[key];
          }
        });
      }
      newStepUI.step.parameters = foundDStep.parameters;
    }

    //set default values
    Object.values(newStepUI.step.parameters).forEach((param) => {
      if(param.value === undefined){
        if(param.type == 'LIST' && param.defaultListValue){
          this.setDefaultListValue(param);
        }else if(param.defaultValue !== undefined){
          param.value = param.defaultValue;
        }
      }
  
      if((param.valueList === undefined || param.valueList.length === 0) &&
          param.type == "CHECK_LIST"){
        param.valueList = param.defaultListValue;
      }
    });

    this.validateDependency(newStepUI.step);

    newStepUI.dragHandle = {className: 'otsc-icon-status-drag-handle', altText: $localize`Drag and drop to reorder steps` };
    newStepUI.uiDisplayName = {html: `<div class="ot-level" style="padding-top:8px"><div class="ot-level__left"><div class="ot-level__item"><strong>${newStepUI.step.nickname}</strong></div></div></div><span>${newStepUI.step.label ? newStepUI.step.label : ''}</span>`, altText: newStepUI.step.nickname };;
    newStepUI.dragPreview = newStepUI.uiDisplayName

    if(sysVar !== undefined){
      newStepUI.uiSystemVariables = sysVar;
    }else{
      if(newStepUI.step.type == this.multiStepType){
        newStepUI.uiSystemVariables = new DataTableDropDownData("NA", [new DataTableDropDownOption($localize`Not applicable`, 'NA')]);
      } else {
        //automatically select the System varible if there's only one option
        //the length is 2 because of the default 'Select a system variable' option
        if(this.stepSystemVariableOptions.length == 2){
          newStepUI.step.selectedSystemVar = {name: this.stepSystemVariableOptions[1].name, value: this.stepSystemVariableOptions[1].value, count: 0};
        }

        if(this.plan && this.plan.steps && this.plan.steps[newStepUI.step.stepNo] !== undefined && newStepUI.step.selectedSystemVar !== undefined){
          this.plan.steps[newStepUI.step.stepNo].selectedSystemVar = JSON.parse(JSON.stringify(newStepUI.step.selectedSystemVar));
        }

        if(this.planCopy && this.planCopy.steps && this.planCopy.steps[newStepUI.step.stepNo] !== undefined && newStepUI.step.selectedSystemVar !== undefined){
          this.planCopy.steps[newStepUI.step.stepNo].selectedSystemVar = JSON.parse(JSON.stringify(newStepUI.step.selectedSystemVar));
        }

        newStepUI.uiSystemVariables = new DataTableDropDownData(newStepUI.step.selectedSystemVar ? newStepUI.step.selectedSystemVar.name : '', this.stepSystemVariableOptions);
      }
    }
    newStepUI.uiStepValidation = this.validateStep(newStepUI, this.plan.variables);
    newStepUI.uiStatus = this.getStepStatus(newStepUI);

    return newStepUI;
  }

  //get parameter data from plan callback
  getParameterData(parameter:Parameter, fieldToSet:string): void {
    if(parameter[fieldToSet] === undefined){
      PlanCallbackService[parameter.data](parameter, this.softInvSrv, fieldToSet);
    }
  }

  //validate each step
  //make sure all required parameter values are set and
  //system variable is selected
  validateStep(stepUI:StepUI, variables: Variable[] = undefined): StepValidation {
    let vType:StepValidation = {type: STEP_VALIDATION_TYPE.VALID, reason: ''};
    if(stepUI.step.type != this.multiStepType){
      //check system variable
      let index:number = this.systemVarRows.findIndex(row => row.data.systemVarName === stepUI.uiSystemVariables.value);

      if(index < 0){
        return {type: STEP_VALIDATION_TYPE.SYSVAR_ERROR, reason: $localize`System variable not found`};
      }else if(this.systemVarRows[index].error){
        return {type: STEP_VALIDATION_TYPE.SYSVAR_ERROR, reason: $localize`System variable contains error`};
      }
    }

    //check each parameters
    let parameters:Parameter[] = Object.values(stepUI.step.parameters);

    for(let i =0; i < parameters.length; i++){
      if (variables !== undefined && parameters[i].variableName != undefined && parameters[i].variableName !== "") {
        for (let j = 0; j < variables.length; j++) {
          if (variables[j].name === parameters[i].variableName) {
            parameters[i].isSensitiveVariable = variables[j].sensitive;
            break;
          }
        }
      }

      if(parameters[i].visible && parameters[i].required && !parameters[i].sensitive && (
        ((parameters[i].value === undefined || parameters[i].value === '') && !parameters[i].isSensitiveVariable) &&
        (parameters[i].valueList === undefined || parameters[i].valueList.length == 0) &&
        (parameters[i].objectList === undefined || parameters[i].objectList.length == 0))){
          vType = {type: STEP_VALIDATION_TYPE.REQ_PARAM_MISSING_ERROR, reason: $localize`${parameters[i].displayName} value in ${parameters[i].group == '' ? 'Default' : parameters[i].group} group is missing`};
          break;
      }
    };

    //check multi system configuration
    if(stepUI.step.type == this.multiStepType){
      let selectedCount: number = 0;
      let validSystems: boolean = true;
      let isAdd: boolean = false;
      for(let i =0; i < parameters.length; i++){
        if(parameters[i].name == "cluster.systems"){
          if(parameters[i].valueList == undefined && parameters[i].defaultListValue == undefined){
            isAdd = false;
          } else {
            let sysList: any[] = parameters[i].valueList;
            for(let sys = 0; sys < sysList.length; sys++){
                if(sysList[sys].selected){
                  selectedCount++;
                  let foundValidSystem: boolean = false;
                  for(let agent = 0; agent < this.solutionInfo.currentEnvironment.agents.length; agent++){
                    if(this.solutionInfo.currentEnvironment.agents[agent].macAddress == sysList[sys].data.macAddress){
                      foundValidSystem = true;
                      break;
                    }
                  }

                  if(!foundValidSystem){
                    validSystems = false;
                  }
                }
            }
            break;
          }
        }
      }

      if(!isAdd && selectedCount == 0){
        return {type: STEP_VALIDATION_TYPE.REQ_PARAM_MISSING_ERROR, reason: $localize`One or more systems must be selected.`};
      } else if(!validSystems){
        return {type: STEP_VALIDATION_TYPE.REQ_PARAM_MISSING_ERROR, reason: $localize`One or more selected systems are not valid for the current environment`};
      }
    }


    return vType;
  }

  //get step status icons
  getStepStatus(stepUI:StepUI): any {
    let altText:string = '';
    let className:string = '';

    //step is disabled
    if(stepUI.step.disabled){
      altText = $localize`Step disabled`;
      className = 'otsc-icon-status-ignore';
    //step is enabled and invalid
    }else if(!stepUI.step.disabled && stepUI.uiStepValidation.type !== STEP_VALIDATION_TYPE.VALID){
      altText = stepUI.uiStepValidation.reason;
      className = 'otsc-icon-status-error';
    }else{
      className = 'otsc-icon-status-available';
      altText = $localize`Ready to be executed`;
    }

    return {altText: altText, className: className}
  }

  //get step action menus
  getStepMenu(index:number, step: Step ): ActionMenuItem[] {
    let stepMenu:ActionMenuItem[] = [new ActionMenuItem("Details", $localize`Edit`, ActionMenuIcon.EDIT, step, false),
                                     new ActionMenuItem("Delete", $localize`Remove`, ActionMenuIcon.DELETE, step, true),
                                     new ActionMenuItem("Duplicate", $localize`Duplicate`, ActionMenuIcon.COPY, step, false)];

    if(step.disabled){
      stepMenu.push(new ActionMenuItem("Enable", $localize`Enable`, ActionMenuIcon.SHOW, step, true));
    }else{
      stepMenu.push(new ActionMenuItem("Disable", $localize`Disable`, ActionMenuIcon.HIDE, step, true));
    }

    if(index != 0){
      stepMenu.push(new ActionMenuItem("MoveUp", $localize`Move up` , ActionMenuIcon.SORT_UP, step, false));
    }

    if(index != this.plan.steps.length - 1){
      stepMenu.push(new ActionMenuItem("MoveDown", $localize`Move Down`, ActionMenuIcon.SORT_DOWN, step, false));
    }

    return stepMenu;
  }

  //switch to another step
  switchStep(currStepIndex:number): void {
    //warn users if the changes are not saved
    if(!this.canDeactivate()){
      const sub: Subscription =
                this.modal.open(ModalMessageComponent, this.getDeactivateModalMessageConfig()
                ).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
                  if(!isPrimaryBtnClicked){
                    //revert changes
                    this.currentStep = this.currentStepCopy;
                    this.plan.variables = this.planVariablesCopy;
                    this.plan.steps[this.currentStep.stepNo] = this.currentStep;
                    this.stepRows[this.currentStep.stepNo].data = this.updateStep(this.currentStep, undefined, this.stepRows[this.currentStep.stepNo].data.uiSystemVariables);
                    this.currentStep = undefined;
                    this.currentStepCopy = undefined;
                    this.setCurrentStep(currStepIndex);
                  }
                  sub.unsubscribe();
                });
    }else{
      this.setCurrentStep(currStepIndex);
    }
  }
  //shows current step on the UI
  setCurrentStep(currStepIndex:number): void {
    this.isCurrentStepLoading = true;

    setTimeout(()=> {
      if(this.currentStep){
        this.updateStep(this.currentStep, undefined);
        this.stepRows[this.currentStep.stepNo].data.uiStepValidation = this.validateStep(this.stepRows[this.currentStep.stepNo].data, this.plan.variables);
        this.stepRows[this.currentStep.stepNo].data.uiStatus = this.getStepStatus(this.stepRows[this.currentStep.stepNo].data);
      }
      this.currentStep = this.stepRows[currStepIndex].data.step;
      this.currentStepCopy = JSON.parse(JSON.stringify(this.currentStep));
      this.planVariablesCopy = JSON.parse(JSON.stringify(this.plan.variables));
      this.currentStepTab = this.currentStep.parameterGroups[0];
  
      Object.values(this.currentStep.parameters).forEach((param) => {
        if(param.variableName && param.variableName != ''){
          let existingVar:Variable = this.plan.variables.find((v) => {return v.name == param.variableName && v.type == param.type;});
  
          if(existingVar){
            param.value = existingVar.value;
          }else{
            param.variableName = '';
          }
        }
      });
  
      this.validateDependency(this.currentStep);
      this.detailState = PlansDetailsState.VIEW_DETAILS;
      this.isCurrentStepLoading = false;
    }, 100);
  }

  //set default list value
  setDefaultListValue(param:Parameter):void {
    for(var i = 0; i < param.defaultListValue.length; i++) {
      if(param.defaultListValue[i].selected){
        param.value = param.defaultListValue[i].value;
        break;
      }
    }
  }

  //on list select
  onListSelect(parameter:Parameter): void {
    this.setVarValFromParam(parameter);
    if(this.currentStep){
      this.updateStep(this.currentStep, undefined);
      this.currentStep = JSON.parse(JSON.stringify(this.currentStep));
    }
  }

  //on checklist change
  onCheckListChange(param:Parameter): void {
    this.validateDependency(this.currentStep);
    this.setVarValFromParam(param);
  }

  //on external vendor file select
  onExtVenFileSelect(extVenderFile:ExtVendorFile, param:Parameter): void {
    param.value = extVenderFile;

    if(param.dependencies && param.dependencies.length > 0){
      this.validateDependency(this.currentStep);
    }
    this.setVarValFromParam(param);
  }

  //on external vendor file deselect
  onExtVenFileDeselect(param:Parameter): void {
    if(param.variableName && param.variableName != ''){
      let existingVar:Variable = this.plan.variables.find((v) => {return v.name == param.variableName && v.type == param.type;});

      if(existingVar){
        existingVar.value = undefined;
      }
    }
    param.value = '';
  }

  //get external vendor file value
  getExtVenFileVal(value:any): any {
    let val:any;

    if(value){
      if(value.name && value.name != ''){
        val = value.name;
      }else if(value.localFilename && value.localFilename != ''){
        val = value.localFilename;
      }else{
        val = value;
      }
    }else{
      val = '';
    }

    return val;
  }
  //on product file select
  onProdFileSelect(prodFile:ProductDownloadInfo, param:Parameter): void {
    param.value = prodFile;
    param.data = prodFile.uid;
    this.forceRefreshComp = !this.forceRefreshComp;

    // product version
    if(this.currentStep){
      Object.values(this.currentStep.parameters).filter(p => {
        return p.type == 'PRODUCT_VERSION';
      }).forEach( p => {
        p.value = prodFile.version;
      });
      this.updateStep(this.currentStep, undefined);
    }
    
    this.setVarValFromParam(param);
  }

  //on product file deselect
  onProdFileDeselect(param:Parameter): void {
    if(param.variableName && param.variableName != ''){
      let existingVar:Variable = this.plan.variables.find((v) => {return v.name == param.variableName && v.type == param.type;});

      if(existingVar){
        existingVar.value = undefined;
      }
    }

    param.value = '';

    if(this.currentStep){
      // product version
      Object.values(this.currentStep.parameters).filter(p => {
        return p.type == 'PRODUCT_VERSION';
      }).forEach( p => {
        p.value = '';
      });

      if(param.dependentParameter){
        this.updateStep(this.currentStep, undefined);
      }
    }
  }

  // SELECT_STEP state
  //show deployment steps
  showDeploymentSteps(): void {
    this.detailState = PlansDetailsState.SELECT_STEP;
    this.getDeploymentSteps();
  }

  //get deployment steps based on pagination
  getDeploymentSteps(): void {
    this.deploymentStepRows = [];
    this.deploymentSteps.forEach(step => {
      this.deploymentStepRows.push(new DataTableRow(step, [new ActionMenuItem("Add", $localize`Add`, ActionMenuIcon.ADD, step, true)]));
    });
  }

  //sort deployment steps based on column
  sortStepList(col: DataTableColumn): void {
    if(col.sortDirection == ColumnSort.ASC){
      this.deploymentSteps.sort((a, b) => (a[col.field] < b[col.field] ? -1 : 1));
    }else{
      this.deploymentSteps.sort((a, b) => (a[col.field] < b[col.field] ? 1 : -1));
    }
    
    this.getDeploymentSteps();
  }

  //handle deployement step table action menu
  deploymentStepActionMenuClicked(event: ActionMenuEvent): void {
    if(event.name === "Add"){
      this.addSteps(event.data);
    }
  }

  //add deployement step to plan
  addSteps(stepsToAdd:Step[]): void {
    const sub: Subscription =
      this.modal.open(ModalMessageComponent, {
        data: {
          title: $localize`Add steps`,
          message: stepsToAdd.length > 1 ? $localize`${stepsToAdd.length} steps are selected. Do you want to add the selected steps?` :
            $localize`<b>${stepsToAdd[0].nickname}</b> step is selected. Do you want to add the selected step?`,
          primaryBtn: $localize`Yes`,
          secondaryBtn: $localize`No`,
          width: '350px',
        },
        id: 'otsc-plans-add-step'
      }
      ).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
        if (isPrimaryBtnClicked) {
          let newStepIndex: number = this.stepRows.length;

          stepsToAdd.forEach(step => {
            let stepToAdd: StepUI = this.updateStep(JSON.parse(JSON.stringify(step)), undefined);
            this.setInitialData(stepToAdd.step);
            let row: DataTableRow = new DataTableRow(stepToAdd, []);
            row.canDrag = true;
            row.disableDropdown = (step.type == this.multiStepType);
            this.stepRows.push(row);
            this.plan.steps.push(stepToAdd.step);
          });

          this.stepRows.forEach((row, index) => {
            row.actions = this.getStepMenu(index, row.data.step);
            row.data.step.stepNo = index;
          });

          this.deploymentStepRows.forEach(row => {
            row.selected = false;
          });

          Utils.addHeaderMessageEventBanner(this.eventService, Events.SuccessMsg, stepsToAdd.length > 1 ? $localize`${stepsToAdd.length} steps were added successfully.` :
            $localize`${stepsToAdd[0].nickname} step was added successfully.`);
          this.recountSelectedRow = !this.recountSelectedRow;

          this.setCurrentStep(newStepIndex);
          this.setCounts();
        }
        sub.unsubscribe();
      });
  }

  // handle step action menus
  actionMenuClicked(event: ActionMenuEvent): void {
    if(event.name === "MoveUp"){
      this.stepRows[event.rowIndex].selected = false;
      this.stepRows.splice(event.rowIndex-1, 0, this.stepRows.splice(event.rowIndex, 1)[0]);
      this.stepRows[event.rowIndex-1].actions = this.getStepMenu(event.rowIndex-1, this.stepRows[event.rowIndex-1].data.step);
      this.stepRows[event.rowIndex-1].data.step.stepNo = event.rowIndex-1;
      this.stepRows[event.rowIndex].actions = this.getStepMenu(event.rowIndex, this.stepRows[event.rowIndex].data.step);
      this.stepRows[event.rowIndex].data.step.stepNo = event.rowIndex;
      this.recountSelectedRowStepsTable = !this.recountSelectedRowStepsTable;
    }else if(event.name === "MoveDown"){
      this.stepRows[event.rowIndex].selected = false;
      this.stepRows.splice(event.rowIndex+1, 0, this.stepRows.splice(event.rowIndex, 1)[0]);
      this.stepRows[event.rowIndex+1].actions = this.getStepMenu(event.rowIndex+1, this.stepRows[event.rowIndex+1].data.step);
      this.stepRows[event.rowIndex+1].data.step.stepNo = event.rowIndex+1;
      this.stepRows[event.rowIndex].actions = this.getStepMenu(event.rowIndex, this.stepRows[event.rowIndex].data.step);
      this.stepRows[event.rowIndex].data.step.stepNo = event.rowIndex;
      this.recountSelectedRowStepsTable = !this.recountSelectedRowStepsTable;
    }else if(event.name === "Details"){
      this.setCurrentStep(event.rowIndex);
    }else if(event.name === "Enable"){
      if(event.data.length > 1){
        let steps:Step[] = [];
        event.data.forEach( data => {
          steps.push(data.step);
        });
        this.enableSteps(steps);
      }else{
        this.enableStep(event.data[0].step ? event.data[0].step : event.data[0], event.rowIndex);
      }
    }else if(event.name === "Disable"){
      if(event.data.length > 1){
        let steps:Step[] = [];
        event.data.forEach( data => {
          steps.push(data.step);
        });
        this.disableSteps(steps);
      }else{
        this.disableStep(event.data[0].step ? event.data[0].step : event.data[0], event.rowIndex);
      }
    }else if(event.name === "Delete"){
      if(event.data.length > 1){
        let stepsToDelete:Step[] = [];
        event.data.forEach( data => {
          stepsToDelete.push(data.step);
        })
        this.removeSteps(stepsToDelete);
      }else{
        this.removeSteps([event.data[0].step ? event.data[0].step : event.data[0]]);
      }
    }else if(event.name == "Duplicate"){
      this.duplicateStep(event.data[0].step ? event.data[0].step : event.data[0], event.rowIndex);
    }
  }

  //enable step
  enableStep(step:Step, index:number): void {
    const sub: Subscription =
      this.modal.open(ModalMessageComponent, {
        data: {
          title: $localize`Enable`,
          message: $localize`<b>${step.nickname}</b> step will be enabled and included in execution. Enable selected step?`,
          primaryBtn: $localize`Enable`,
          secondaryBtn: $localize`Cancel`,
          width: '350px'
        },
        id: 'otsc-plans-enable-step-msg'
      }).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
        if (isPrimaryBtnClicked) {
          step.disabled = false;
          this.stepRows[index].data = this.updateStep(step, undefined);
          this.stepRows[index].actions = this.getStepMenu(index, step);
          this.stepRows[index].selected = false;
          this.recountSelectedRowStepsTable = !this.recountSelectedRowStepsTable;
          Utils.addHeaderMessageEventBanner(this.eventService, Events.SuccessMsg, $localize`${step.nickname} was enabled successfully.`);
        }
        sub.unsubscribe();
      });
  }

  enableSteps(steps:Step[]): void {
    const sub: Subscription =
      this.modal.open(ModalMessageComponent, {
        data: {
          title: $localize`Enable`,
          message: $localize`You have selected ${steps.length} steps to enable.<br/> Enable the selected steps?`,
          primaryBtn: $localize`Enable`,
          secondaryBtn: $localize`Cancel`,
          width: '350px'
        },
        id: 'otsc-plans-enable-steps-msg'
      }).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
        if (isPrimaryBtnClicked) {
          steps.forEach((step) => {
            let index:number = this.stepRows.findIndex(s => s.data.step.stepNo === step.stepNo);
            if (index > -1) {
              step.disabled = false;
              this.stepRows[index].data = this.updateStep(step, undefined);
              this.stepRows[index].actions = this.getStepMenu(index, step);
              this.stepRows[index].selected = false;
            }
          });
          this.recountSelectedRowStepsTable = !this.recountSelectedRowStepsTable;
          Utils.addHeaderMessageEventBanner(this.eventService, Events.SuccessMsg, $localize`${steps.length} steps were enabled.`);
        }
        sub.unsubscribe();
      });
  }

  //disable step
  disableStep(step:Step, index:number): void {
    const sub: Subscription =
      this.modal.open(ModalMessageComponent, {
        data: {
          title: $localize`Disable`,
          message: $localize`<b>${step.nickname}</b> step will be disabled and excluded from execution. Disable selected step?`,
          primaryBtn: $localize`Disable`,
          secondaryBtn: $localize`Cancel`,
          width: '350px'
        },
        id: 'otsc-plans-disable-step-msg'
      }).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
        if (isPrimaryBtnClicked) {
          step.disabled = true;
          this.stepRows[index].data = this.updateStep(step, undefined);
          this.stepRows[index].actions = this.getStepMenu(index, step);
          this.stepRows[index].selected = false;
          this.recountSelectedRowStepsTable = !this.recountSelectedRowStepsTable;
          Utils.addHeaderMessageEventBanner(this.eventService, Events.SuccessMsg, $localize`${step.nickname} was disabled successfully.`);
        }
        sub.unsubscribe();
      });
  }

  disableSteps(steps:Step[]): void {
    const sub: Subscription =
      this.modal.open(ModalMessageComponent, {
        data: {
          title: $localize`Disable`,
          message: $localize`You have selected ${steps.length} steps to disable.<br/> Disable the selected steps?`,
          primaryBtn: $localize`Disable`,
          secondaryBtn: $localize`Cancel`,
          width: '350px'
        },
        id: 'otsc-plans-disable-steps-msg'
      }).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
        if (isPrimaryBtnClicked) {
          steps.forEach((step) => {
            let index:number = this.stepRows.findIndex(s => s.data.step.stepNo === step.stepNo);
            if (index > -1) {
              step.disabled = true;
              this.stepRows[index].data = this.updateStep(step, undefined);
              this.stepRows[index].actions = this.getStepMenu(index, step);
              this.stepRows[index].selected = false;
            }
          });
          this.recountSelectedRowStepsTable = !this.recountSelectedRowStepsTable;
          Utils.addHeaderMessageEventBanner(this.eventService, Events.SuccessMsg, $localize`${steps.length} steps were disabled.`);
        }
        sub.unsubscribe();
      });
  }

  //remove step
  removeSteps(steps:Step[]): void {
    const sub: Subscription =
      this.modal.open(ModalMessageComponent, {
        data: {
          title: $localize`Remove`,
          message: steps.length == 1 ? $localize`<b>${steps[0].nickname}</b> will be removed. Remove selected step?` :
            $localize`${steps.length} steps will be removed. Remove selected steps?`,
          primaryBtn: $localize`Remove`,
          secondaryBtn: $localize`Cancel`,
          width: '350px'
        },
        id: 'otsc-plans-remove-steps-msg'
      }).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
        if (isPrimaryBtnClicked) {
          let deleteSteps: number = 0;
          steps.forEach(step => {
            let index: number = this.stepRows.findIndex(s => s.data.step.stepNo === step.stepNo);
            if (index > -1) {
              this.stepRows.splice(index, 1);
              this.plan.steps.splice(index, 1);
              deleteSteps++;
            }
          });

          if (deleteSteps == steps.length) {
            Utils.addHeaderMessageEventBanner(this.eventService, Events.SuccessMsg,
              steps.length == 1 ?
                $localize`${steps[0].nickname} was removed successfully.` :
                $localize`${steps.length} steps were removed successfully.`);
            if (this.stepRows.length > 0) {
              this.stepRows.forEach((row, index) => {
                row.actions = this.getStepMenu(index, row.data.step);
                row.data.step.stepNo = index;
              });
              this.currentStep = this.stepRows[0].data.step;
            } else {
              this.currentStep = undefined;
              this.showDeploymentSteps();
            }
          } else {
            Utils.addHeaderMessageEventBanner(this.eventService, Events.ErrorMsg,
              steps.length == 1 ?
                $localize`${steps[0].nickname} could not be removed. Please try again later.` :
                $localize`${steps.length} steps could not be removed. Please try again later.`);

          }
          this.recountSelectedRowStepsTable = !this.recountSelectedRowStepsTable;
        }
        this.setCounts();
        sub.unsubscribe();
      });
  }

  //duplicate step
  duplicateStep(step:Step, index:number): void {
    const sub: Subscription =
      this.modal.open(ModalMessageComponent, {
        data: {
          title: $localize`Duplicate`,
          message: $localize`<b>${step.nickname}</b> step will be duplicated. Duplicate selected step?`,
          primaryBtn: $localize`Duplicate`,
          secondaryBtn: $localize`Cancel`,
          width: '350px'
        },
        id: 'otsc-plans-duplicate-step-msg'
      }).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
        if (isPrimaryBtnClicked) {
          //unselect rows
          this.stepRows[index].selected = false;
          let tmpRows: DataTableRow[] = JSON.parse(JSON.stringify(this.stepRows));
          
          //duplicate a row
          tmpRows.splice(index + 1, 0, JSON.parse(JSON.stringify(tmpRows[index])));

          //update variable count
          Object.values(tmpRows[index + 1].data.step.parameters).forEach((param: Parameter) => {
            if (param.variableName && param.variableName != '') {
              let existingVar: Variable = this.plan.variables.find((v) => { return v.name == param.variableName && v.type == param.type; });

              if (existingVar) {
                existingVar.count++;
              }
            }
          });

          this.stepRows = tmpRows;
          this.plan.steps.splice(index + 1, 0, this.stepRows[index].data.step);

          Utils.addHeaderMessageEventBanner(this.eventService, Events.SuccessMsg, $localize`${step.nickname} was duplicated successfully.`);
          if (this.stepRows.length > 0) {
            this.stepRows.forEach((row, index) => {
              row.actions = this.getStepMenu(index, row.data.step);
              row.data.step.stepNo = index;
            });
          } else {
            this.currentStep = undefined;
            this.showDeploymentSteps();
          }

          this.recountSelectedRowStepsTable = !this.recountSelectedRowStepsTable;
        }
        sub.unsubscribe();
      });
  }

  // when step system variable changed
  stepSysVarChanged(row:DataTableRow): void {
    row.data.uiStepValidation = this.validateStep(row.data, this.plan.variables);
    row.data.uiStatus = this.getStepStatus(row.data);
  }

  //
  //  Variables
  //
  //set parameter value from a variable
  setParamValFromVariable(variable:Variable, param:Parameter): void {
    let existingVar:Variable = this.plan.variables.find((v) => {return v.name == variable.name && v.type == variable.type;});

    //update count if existing variable
    if(existingVar){
      existingVar.count++;
      param.value = existingVar.value;
      param.variableName = variable.name;
      param.isSensitiveVariable = variable.sensitive;
      this.plan.steps[this.currentStep.stepNo] = this.currentStep;
    }else{
      param.variableName = '';
    }

    param.focus = false; //hide variable dropdown
  }

  //add new variable
  addVariable(variableName: string, param:Parameter): void{
    param.varSearch = variableName;

    //new variable name is entered
    if(param.varSearch != ''){
      let existingVar:Variable = this.plan.variables.find((v) => {return v.name == param.varSearch && v.type == param.type;});
      
      if(existingVar){
        this.setParamValFromVariable(existingVar, param);
      }else{
        let newVar:Variable = {count: 1, name: param.varSearch, type: param.type, value: this.getValFromParam(param), parameter: param, sensitive: false};
        this.plan.variables.push(newVar);
        param.variableName = newVar.name;
        param.varSearch = '';
        param.focus = false;
        this.plan.steps[this.currentStep.stepNo] = this.currentStep;
      }
    }
    this.setCounts();
  }

  //remove variable
  removeVariable(variableName: string, param:Parameter): void {
    let index:number = this.plan.variables.findIndex((v) => {return v.name == param.variableName && v.type == param.type;});

    if(index > -1){
      //last one?
      if(this.plan.variables[index].count == 1){
        this.plan.variables.splice(index, 1);
      }else{
        this.plan.variables[index].count--;
      }
      
      param.variableName = "";
      param.isSensitiveVariable = false;
      this.plan.steps[this.currentStep.stepNo] = this.currentStep;
    }

    this.setCounts();
  }

  //set variable value from parameter
  setVarValFromParam(param:Parameter, step?: Step):  void {   
    let existingVar:Variable = this.plan.variables.find((v) => {return v.name == param.variableName && v.type == param.type;});

    //update existing variable
    if(existingVar){
      existingVar.value = this.getValFromParam(param);
      //update parameters with the same variable name
      this.plan.steps.forEach( step => {
        Object.values(step.parameters).forEach(p => {
          if(p.type == param.type && p.variableName == existingVar.name){
            p.value = existingVar.value;
          }
        });
      });
    }
    if(step){
      this.validateDependency(step);
    }
  }

  //update parameter values when variable value is change from variables tab
  onVarValChanged(variable:Variable): void {
    //update parameters with the same variable name
    this.plan.steps.forEach( step => {
      Object.values(step.parameters).forEach(p => {
        if(p.type == variable.type && p.variableName == variable.name){
          p.value = variable.value;
        }
      });
      this.updateStep(step, undefined);
    });
  }

  //on remove variable button click
  onRemoveVarBtnClick(variable:Variable): void {
    const sub: Subscription =
      this.modal.open(ModalMessageComponent, {
        data: {
          title: $localize`Remove variable`,
          message: $localize`This action will remove the selected variable in your plan. Do you want to remove <b>${variable.name}</b>?`,
          primaryBtn: $localize`Yes`,
          secondaryBtn: $localize`No`,
          width: '450px',
        },
        id: 'otsc-plans-remove-var-confirm'
      }
      ).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
        if (isPrimaryBtnClicked) {
          //delete variables in parameters
          this.plan.steps.forEach(step => {
            Object.values(step.parameters).forEach(p => {
              if (p.type == variable.type && p.variableName == variable.name) {
                p.variableName = '';
                p.isSensitiveVariable = false;
              }
            });
          });
          //delete variable from plan
          let index: number = this.plan.variables.findIndex((v) => { return v.name == variable.name && v.type == variable.type; });

          if (index > -1) {
            this.plan.variables.splice(index, 1);
            this.plan.variables = [...this.plan.variables]; //reassign array to update the changes on UI
            Utils.addHeaderMessageEventBanner(this.eventService, Events.SuccessMsg, $localize`${variable.name} was removed successfully.`);
          }
        }
        this.setCounts();
        sub.unsubscribe();
      });
  }

  //helper method to get values from different parameter types
  getValFromParam(param:Parameter): any {
    let newVal:any;

    if(param.type === 'CHECK_LIST'){
      newVal = param.valueList;
    }else if(param.type === 'PRODUCT_FILE'){
      newVal = param.value && param.value.name ? param.value : param.value ? {name: param.value} : param.value;
    }else if(param.type === 'EXT_FILE'){
      newVal = param.value && param.value.localFilename ? param.value : param.value ? {localFilename: param.value} : param.value;
    }else{
      newVal = param.value;
    }
    
    return newVal;
  }

  //
  // System Variables
  //

  //when system variable is changed
  systemVariablesChanged(row:DataTableRow): void {
    let agent:Agent = this.getAgentBySysName(this.plan.selectedEnvironmentId, row.data.systemList.value);
    row.data.systemStatus = agent ? Utils.getAgentStatus(agent) : new AgentStatus(AgentStatusValue.OFFLINE, 'otsc-icon-status-outdated', $localize`Agent status is unknown`);
    row.data.macAddress = agent ? agent.macAddress : '';
    this.validateSystemVariables();
  }

  //validate system variables
  validateSystemVariables(): void {
    this.systemVarRows.forEach( (systemVarRow:DataTableRow) => {
      let selectedOption = systemVarRow.data.systemList.options.find( option => {
        return option.name == systemVarRow.data.systemList.value;
      });

      if(selectedOption){
        if (selectedOption.value == ''){
          systemVarRow.error = true;
          systemVarRow.errorText = $localize`Please select a system` ;
        }else if (systemVarRow.data.systemVarName == ''){
          systemVarRow.error = true;
          systemVarRow.errorText = $localize`Please enter system variable name` ;
        }else{
          let sysVarNameCounter:number = 0;
          this.systemVarRows.forEach( (row: DataTableRow) => {
            if(systemVarRow.data.systemVarName == row.data.systemVarName){
              sysVarNameCounter++;
            }
          });
          //duplicates are found
          if(sysVarNameCounter > 1){
            systemVarRow.error = true;
            systemVarRow.errorText = $localize`Please enter a unique system variable name.`;
          }else{
            systemVarRow.error = false;
            systemVarRow.errorText = '';
          }
        }
      }else{
        systemVarRow.error = true;
        systemVarRow.errorText = $localize`Please select a system` ;
      }
    });
  }

  //handle system variables table action menu
  systemVariablesActionMenuClicked(event: ActionMenuEvent): void {
    if(event.name === 'Delete'){
      const sub: Subscription =
        this.modal.open(ModalMessageComponent, {
          data: {
            title: $localize`Remove system variables`,
            message: event.data.length > 1 ? $localize`${event.data.length} system variables are selected. Do you want to remove the selected system variables?` :
              $localize`Do you want to remove the selected system variable?`,
            primaryBtn: $localize`Yes`,
            secondaryBtn: $localize`No`,
            width: '350px',
          },
          id: 'otsc-plans-remove-sys-var'
        }
        ).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
          if (isPrimaryBtnClicked) {
            //delete plan system variable
            let selectedRows: DataTableRow[] = this.systemVarRows.filter((row: DataTableRow) => {
              return row.selected;
            });

            if (selectedRows.length > 0) {
              selectedRows.forEach((row: DataTableRow) => {
                let index: number = this.plan.systemVariables.findIndex((sysVar: SystemVariable) => {
                  return sysVar.name == row.data.systemVarName;
                });

                if (index > -1) {
                  this.plan.systemVariables.splice(index, 1);
                }

                //update step system variable options
                let optionsIndex: number = this.stepSystemVariableOptions.findIndex(option => {
                  return option.name == row.data.systemVarName;
                });

                if (optionsIndex > -1) {
                  this.stepSystemVariableOptions.splice(optionsIndex, 1);
                }
              });
            }
            //delete selected rows
            event.data.forEach((data: any) => {
              let index: number = this.systemVarRows.findIndex((row: DataTableRow) => {
                return row.data.systemVarName == data.systemVarName &&
                  row.data.macAddress == data.macAddress;
              });

              if (index > -1) {
                this.systemVarRows.splice(index, 1);
              }
            });

            this.recountSelectedSystemVarTable = !this.recountSelectedSystemVarTable;
            this.setCounts();
          }
          sub.unsubscribe();
        });
    }
  }

  //add new system variable
  addNewSystemVariableRow(): void {
    let sysVar = {systemVarName: '',
      prevSystemVarName: '',
      systemList: new DataTableDropDownData('', this.systemVariableOptions),
      systemStatus: new AgentStatus(AgentStatusValue.OFFLINE, 'otsc-icon-status-outdated', $localize`Agent status is unknown`),
      macAddress: '',
     };
    let newSysVarRow:DataTableRow = new DataTableRow(sysVar, [new ActionMenuItem("Delete", $localize`Remove`, ActionMenuIcon.DELETE, sysVar, true)], true);
    newSysVarRow.errorText = $localize`Please enter system variable name` ;

    let tmpRows: DataTableRow[]  = JSON.parse(JSON.stringify(this.systemVarRows));
    tmpRows.push(newSysVarRow);
    this.systemVarRows = tmpRows;

    this.setCounts();
  }

  //systemVariablesNameChanged
  systemVariablesNameChanged(row:DataTableRow):void {
    this.validateSystemVariables();

    //update options
    let optionToUpdate:DataTableDropDownOption = this.stepSystemVariableOptions.find( (option) => {
      return option.name == row.data.prevSystemVarName;
    });

    if(optionToUpdate){
      optionToUpdate.name = row.data.systemVarName;
    }else{
      this.stepSystemVariableOptions.push(new DataTableDropDownOption(row.data.systemVarName, row.data.systemVarName));
    }

    //update for steps with previus system variable name
    this.stepRows.forEach( stepRow => {
      stepRow.data.uiSystemVariables.options = this.stepSystemVariableOptions;
      if(stepRow.data.uiSystemVariables.value != '' && stepRow.data.uiSystemVariables.value == row.data.prevSystemVarName){
        stepRow.data.uiSystemVariables.value = row.data.systemVarName;
      }
    });

    row.data.prevSystemVarName = row.data.systemVarName;
  }

  setCounts(): void {
    this.stepsTab.count = this.stepRows.length;
    this.variablesTab.count = this.plan.variables.length;
    this.sysVariablesTab.count = this.systemVarRows.length;
  }

  setInitialData(step: Step): void {
    Object.values(step.parameters).forEach((param: Parameter) => {
      if(param.defaultValueCallback && param.defaultValueCallback !== ""){
        if(typeof PlanCallbackService[param.defaultValueCallback] === "function"){
          let defaultValue = PlanCallbackService[param.defaultValueCallback](step, param, this);
          if(param.type == "CHECK_LIST") {
            param.valueList = defaultValue;
            param.defaultListValue = defaultValue;
          } else {
            param.valueList = defaultValue;
            param.defaultValue = defaultValue;
          }
        }
      }
    });
  }

  onSetVariableSensitiveClick(variable: Variable): void {
    if (variable.sensitive && (variable.value != undefined || variable.value != '') && !this.cookieSrv.check("doNotShowVariableWarnning")) {
      this.showVariableWarning(variable);
    }
  }

  showVariableWarning(variable: Variable): void {
    if (!this.cookieSrv.check("doNotShowVarWarningDlg")) {
      let checkControl: ModalControl = new ModalControl('do-not-show-variable-warning', ModalControlType.CHECKBOX,
        $localize`Do not show again`, false);
      const sub: Subscription =
        this.modal.open(ModalMessageComponent, {
          data: {
            title: $localize`Sensitive variable`,
            message: $localize`This action will remove the current value from this field.  You will be required to enter this value each time the plan is launched.  Would you like to continue with this change?`,
            primaryBtn: $localize`Yes`,
            secondaryBtn: $localize`No`,
            width: '450px',
            controls: [checkControl],
            useResult: true
          },
          id: 'otsc-plans-set-var-sensitive'
        }
        ).afterClosed.subscribe((result: ModalResult) => {
          if(result.controls[0].val){
            this.cookieSrv.set('doNotShowVarWarningDlg', "true");
          }
          if (result.isPrimary) {
            variable.value = '';
          } else {
            variable.sensitive = false;
          }
          sub.unsubscribe();
        });
    } else {
      variable.value = '';
    }
  }

  //
  //private methods
  //

  //initialize the view
  private init(): void {
    this.isStepTableLoading = true;
    this.planId = +this.route.snapshot.paramMap.get('planId');
    this.stepRows = [];
    this.systemVarRows = [];
  }
}
